<template>
  <svg
    enable-background="new 0 0 512 512"
    height="18px"
    viewBox="0 0 512 512"
    width="18px"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <linearGradient
      gradientUnits="userSpaceOnUse"
      id="midweeksvg1"
      x1="256"
      x2="256"
      y1="512"
      y2="0"
    >
      <stop offset="0" stop-color="#fd3a84" />
      <stop offset="1" stop-color="#ffa68d" />
    </linearGradient>
    <linearGradient
      gradientUnits="userSpaceOnUse"
      id="midweeksvg2"
      x1="256"
      x2="256"
      y1="313.812"
      y2="121"
    >
      <stop offset="0" stop-color="#ffc2cc" />
      <stop offset="1" stop-color="#fff2f4" />
    </linearGradient>
    <g>
      <path
        d="m398.283 509.862-142.283-85.369-142.283 85.37c-4.634 2.781-10.406 2.853-15.108.191-4.702-2.663-7.609-7.65-7.609-13.054v-482c0-8.284 6.716-15 15-15h300c8.284 0 15 6.716 15 15v482c0 5.404-2.907 10.391-7.609 13.053-4.695 2.658-10.466 2.595-15.108-.191z"
        fill="url(#midweeksvg1)"
      />
      <path
        d="m301.921 312.088-45.921-24.141-45.921 24.142c-5.053 2.657-11.177 2.214-15.797-1.142-4.619-3.356-6.933-9.043-5.967-14.671l8.771-51.133-37.151-36.213c-4.088-3.985-5.56-9.946-3.795-15.376 1.764-5.43 6.458-9.388 12.109-10.209l51.341-7.46 22.96-46.523c2.527-5.12 7.742-8.361 13.451-8.361s10.924 3.242 13.451 8.361l22.96 46.523 51.341 7.46c5.65.821 10.345 4.779 12.109 10.209 1.765 5.43.293 11.391-3.795 15.376l-37.151 36.213 8.771 51.133c.965 5.627-1.348 11.315-5.967 14.671-4.596 3.337-10.719 3.813-15.799 1.141z"
        fill="url(#midweeksvg2)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "grandJackpotImage",
};
</script>
